import { CloseOutlined } from '@ant-design/icons';
import { Image, Progress, Button } from 'antd';
import { ProgressStatus } from '@/shared/types';

interface ImagePreviewProps {
  src?: string;
  alt?: string;
  isLoading?: boolean;
  showProgress?: boolean;
  progress?: number;
  progressStatus?: ProgressStatus;
  onClear?: () => void;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
  src,
  alt = 'preview',
  isLoading = false,
  showProgress = false,
  progress = 0,
  progressStatus,
  onClear,
}) => {
  if (!src && !isLoading) return null;

  return (
    <div style={{ marginTop: 20 }}>
      {showProgress && (
        <Progress
          percent={progress}
          size="small"
          status={progressStatus}
          style={{ marginBottom: 10 }}
        />
      )}
      {src && (
        <div style={{ position: 'relative' }}>
          <Image
            src={src}
            alt={alt}
            style={{
              width: '100%',
              borderRadius: 4,
              opacity: isLoading ? 0.7 : 1,
            }}
          />
          {onClear && (
            <Button
              type="text"
              danger
              icon={<CloseOutlined />}
              onClick={onClear}
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: 'rgba(255, 255, 255, 0.8)',
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};
